import * as React from "react";
const SvgMenuDropdownUp = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 9, height: 5, fill: "none", viewBox: "0 0 9 5", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "#02234C", d: "M.233 4.667 4.4.5l4.167 4.167z" }));
export default SvgMenuDropdownUp;
